/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
    GeoPointToJSONTyped,
} from './GeoPoint';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {GeoPoint}
     * @memberof Address
     */
    location?: GeoPoint;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    locality: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    administrativeArea: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    placeId?: string;
}

/**
 * Check if a given object implements the Address interface.
 */
export function instanceOfAddress(value: object): value is Address {
    if (!('locality' in value) || value['locality'] === undefined) return false;
    if (!('administrativeArea' in value) || value['administrativeArea'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if (json == null) {
        return json;
    }
    return {
        
        'location': json['location'] == null ? undefined : GeoPointFromJSON(json['location']),
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'locality': json['locality'],
        'administrativeArea': json['administrativeArea'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'country': json['country'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
    };
}

export function AddressToJSON(json: any): Address {
    return AddressToJSONTyped(json, false);
}

export function AddressToJSONTyped(value?: Address | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'location': GeoPointToJSON(value['location']),
        'line1': value['line1'],
        'line2': value['line2'],
        'locality': value['locality'],
        'administrativeArea': value['administrativeArea'],
        'postalCode': value['postalCode'],
        'country': value['country'],
        'placeId': value['placeId'],
    };
}

